import React, { useState } from 'react'
import TfidbPersonMovie from '../TfidbPersonMovie'
import { capitalizeFirstLetter } from './CapitalizeFirstLetter'
import { FaCaretDown, FaCaretUp } from 'react-icons/fa'
import { Auth } from 'aws-amplify'
import UpdatePersonExtendedInfo from '../../../Services/Mutations/UpdatePersonExtendedInfo'
import { ToastStyle } from '../../Data/MovieStaticData'
import { toast } from 'react-toastify'

function MovieHits({
  section,
  activeSection,
  handleSectionClick,
  label,
  PersoninputData,
  sendInputdata,
  getUpdatedData,
  personData,
  setLoader,
}) {
  const [valueChanged, setValueChanged] = useState(false)
  let loggedInUserHandle = ''
  const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
  if (loggedInUserEmail) {
    const emailParams = loggedInUserEmail.split('@')
    loggedInUserHandle = '@' + emailParams[0]
  }

  const saveMovieHits = async () => {
    setLoader(true)
    const input = {
      PK: personData.PK,
      SK: personData.SK,
      moderatorID: Auth.user.username,
      moderatorHandle: loggedInUserHandle,
      hitMovies: (PersoninputData.hitMovies || []).map(movie => ({
        movieID: movie.PK, // Provide a default value if ID is missing
      })),
    }
    try {
      // Call the UpdatePersonExtendedInfo mutation with the input data
      const update = await UpdatePersonExtendedInfo(input)

      // Check if the update was successful
      if (update.statusCode === '200') {
        // If successful, display success message
        toast.success(`${update.statusMessage}`, ToastStyle)
        // Reload the window to reflect the changes
        getUpdatedData()
        setLoader(false)
        setValueChanged(false)
      } else {
        // If update failed, display error message
        toast.error('Failed to update. Please try again.')
        setLoader(false)
      }

      // Log the update response
    } catch (error) {
      setLoader(false)
      // Catch any errors that occur during the update process
      console.error('Error in SubmitExtendedInfo:', error.message)
    }
  }

  return (
    <div
      id={section}
      className={`accordion-item ${
        activeSection === section || activeSection === 'all' ? 'active' : ''
      }`}
    >
      {/* Accordion header */}
      <h2 className='accordion-header' id='headingThree'>
        {/* Button to toggle the accordion */}
        <button
          className='accordion-button'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapseThree'
          aria-expanded={activeSection === section || activeSection === 'all'}
          aria-controls='collapseThree'
          onClick={() => handleSectionClick(section)}
          style={{ color: 'white' }}
        >
          {/* Display the label with the first letter capitalized */}
          <span>{capitalizeFirstLetter(label)}</span>
          {/* Display the caret icon based on the accordion state */}
          {activeSection === section || activeSection === 'all' ? <FaCaretUp /> : <FaCaretDown />}
        </button>
      </h2>
      {/* Accordion content */}
      <div
        id='collapseThree'
        className={`accordion-collapse collapse ${
          activeSection === section || activeSection === 'all' ? 'show' : ''
        }`}
        aria-labelledby='headingThree'
        data-bs-parent='#accordion'
      >
        <TfidbPersonMovie
          inputData={PersoninputData}
          sendinputdata={sendInputdata}
          name={'hitMovies'}
          inputField1={'hitMovies'}
          setValueChanged={setValueChanged}
          //   disableInput={disableInput}
        />
        {/* Save and Cancel buttons */}
        <div
          className='d-flex'
          style={{ justifyContent: 'center', alignItems: 'center', gap: '5px', marginTop: '5px' }}
        >
          {/* Save button */}
          <button
            className='btn btn-success'
            onClick={() => {
              //   setChangesMade(false)
              saveMovieHits()
            }}
            disabled={!valueChanged} // Disable if no changes made
          >
            save
          </button>
          {/* Cancel button */}
          <button
            className='btn btn-secondary'
            onClick={() => {
              //   setChangesMade(false) // Reset changesMade state
              getUpdatedData() // Call function to get updated data
            }}
            disabled={!valueChanged} // Disable if no changes made
          >
            cancel
          </button>
        </div>
      </div>
    </div>
  )
}

export default MovieHits
